<h2>Select configuration</h2>
<div class="configlist col gap-8">
    <div *ngIf="configList.length == 0">
        No configurations available. Please create a new one.
    </div>
    <div
        class="config card row w100 align-center gap-32"
        [ngClass]="selectedItem?.id === c.id ? 'active' : ''"
        *ngFor="let c of configList"
        (click)="select(c)"
    >
        <div
            class="rdb"
            [ngClass]="selectedItem?.id === c.id ? 'active' : ''"
        ></div>
        <div class="col gap-8 data w100">
            <div class="w100 row space-between">
                <div class="strong">{{ c.name }}</div>
                <div class="row gap-8">
                    <rr-badge tone="info">Credits: {{ c.credits }}</rr-badge>
                    <rr-badge tone="warning"
                        >Duration: {{ c.duration }}</rr-badge
                    >
                <rr-icon
                    class="roundicon w20 pointer"
                    name="edit"
                    (click)="editConfig(c.id)"
                ></rr-icon>
                </div>
            </div>
            <div class="tiny">{{ c.description }}</div>
        </div>
    </div>
</div>
<div class="row gap-8 justify-end">
    <rr-btn type="Secondary" size="Medium" (click)="close()">Cancel</rr-btn>
    <rr-btn
        type="Primary"
        size="Medium"
        [disabled]="selectedItem !== undefined ? false : true"
        (click)="selectedItem !== undefined ? save() : null"
        *ngIf="configList.length > 0"
        >Select</rr-btn
    >
</div>
<rr-spinner *ngIf="isLoading"></rr-spinner>
